import { createFeature, createReducer, on } from '@ngrx/store';
import { SurveyActions } from '../actions/survey.actions';
import { SurveyStateManager } from '../mutators/survey-state.manager';
import { INITIAL_SURVEY_STATE } from '../survey.state';

export const surveyFeatureKey = 'survey';

export const surveyReducer = createReducer(
  INITIAL_SURVEY_STATE,

  on(SurveyActions.init, (state, { context }) =>
    new SurveyStateManager(state).initialize(context),
  ),

  on(SurveyActions.setFilters, (state, { filters }) =>
    new SurveyStateManager(state).setFilters(filters),
  ),

  on(SurveyActions.resetFilters, (state) =>
    new SurveyStateManager(state).resetFilters(),
  ),

  on(SurveyActions.setSort, (state, { sort }) =>
    new SurveyStateManager(state).setSort(sort),
  ),

  on(SurveyActions.reload, (state) => new SurveyStateManager(state).reload()),

  on(SurveyActions.loadNextPage, (state) =>
    new SurveyStateManager(state).loadNextPage(),
  ),

  on(SurveyActions.loadSuccess, (state, { surveys = [] }) =>
    new SurveyStateManager(state).loadSuccess(surveys),
  ),

  on(SurveyActions.loadFailure, (state, { error }) =>
    new SurveyStateManager(state).loadFailure(error),
  ),
);

export const surveyFeature = createFeature({
  name: surveyFeatureKey,
  reducer: surveyReducer,
});
